import { http } from '@/shared/http.ts'

export const getSteamAuthUrl = async (token: string) => {
  return await http.get<{ connect_url: string }>('/steam/connect', {
    token,
  })
}

export const getSteamRefreshData = async (token: string) => {
  return await http.get<{ ok: boolean }>('/steam/refresh', {
    token,
  })
}
export const getEpicRefresh = async (token: string) => {
  return await http.get('/epic/refresh', {
    token,
  })
}

export const getRecommendations = async (token: string) => {
  // TODO: clarify this type
  return await http.get<any>('/steam/favorites', {
    token,
  })
}


